export default __webpack_public_path__ + "static/1-6c9c45b77f0f78c3303db930fb5eeff7.jpeg";